const env = process.env.VUE_APP_ENV;
let API = null;
let CREATEUSER = null;

switch (env) {
	case "production":
		API = "/api";
		CREATEUSER = "https://appcontas.informaticasg.com.br";
		break;
	case "staging":
		API = "/api";
		CREATEUSER = "https://appcontas-homo.informaticasg.com.br";
		break;
	default:
		API = "http://localhost:3000/api";
		CREATEUSER = "http://localhost:3002";
		break;
}
console.log(env, API);

export default {
	API,
	CREATEUSER
};
